import type { CardKind, CardViewModel } from '../types/Cards.types';

const KIND_BY_STATUS = new Map<string, Exclude<CardKind, 'physical-active' | 'digital-active'>>([
  ['NOT_ACTIVATED', 'not-activated'],
  ['BLOCKED', 'blocked'],
  ['CLOSED', 'closed'],
  ['LOST', 'lost'],
  ['STOLEN', 'stolen'],
  ['REPLACED', 'replaced'],
]);

export const deriveCardKind = (card: Pick<CardViewModel, 'status' | 'physicalActivatedAt'>): CardKind => {
  const status = card.status?.toUpperCase() ?? '';

  if (status === 'ACTIVE') return card.physicalActivatedAt ? 'physical-active' : 'digital-active';

  return KIND_BY_STATUS.get(status) ?? 'unknown';
};

const CURRENT_KINDS: ReadonlySet<CardKind> = new Set(['physical-active', 'digital-active', 'not-activated']);

export const isCurrentCard = (kind: CardKind): boolean => CURRENT_KINDS.has(kind);
